import {
  selectActivePrinter,
  selectPrinterError,
} from '@ticketmaster/tm1pos-web-shared/printing/printingModule-selectors';
import { selectHostPermissions } from '@ticketmaster/tm1pos-web-shared/store/selectors/permissions-selector';
import { createSelector } from 'reselect';
import { selectCurrentEventDetails, selectSuccessOrder } from 'containers/App/selectors';
import { selectCurrentEvent } from 'containers/EventDetailPage/selectors/main';

export const selectOrderConfirmationState = createSelector(
  [
    selectActivePrinter,
    selectPrinterError,
    selectSuccessOrder,
    selectCurrentEvent,
    selectCurrentEventDetails,
    selectHostPermissions,
  ],
  (activePrinter, printerError, order, currentEvent, eventDetails, permissions) => ({
    order,
    localPrinterError: printerError,
    selectedPrinter: activePrinter,
    currentEvent,
    hostName: eventDetails?.hostName,
    isAuthorizationOff:
      currentEvent.isHost && eventDetails?.hostName
        ? !permissions?.[eventDetails.hostName].mustAuthorizeCards
        : undefined,
  }),
);
